import axiosInstance from './axiosInstance';

const API_URL = process.env.REACT_APP_API_URL;

// GET all form assignments
export const getFormAssignments = async () => {
  try {
    const response = await axiosInstance.get(`${API_URL}/form-assignments`);
    return response.data;
  } catch (error) {
    console.error("Error fetching form-assignments:", error.response?.data || error);
    throw error;
  }
};

// GET app forms
export const getAppForms = async () => {
  try {
    const response = await axiosInstance.get(`${API_URL}/form-assignments/app`);
    return response.data;
  } catch (error) {
    console.error("Error fetching app forms:", error.response?.data || error);
    throw error;
  }
};

// GET a single form assignment
export const getFormAssignmentById = async (id) => {
  try {
    const response = await axiosInstance.get(`${API_URL}/form-assignments/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching form-assignments:", error.response?.data || error);
    throw error;
  }
};

// CREATE a new form assignment
export const createFormAssignment = async (formAssignmentData) => {
  try {
    const response = await axiosInstance.post(`${API_URL}/form-assignments`, formAssignmentData);
    return response.data;
  } catch (error) {
    console.error("Error creating form-assignments:", error.response?.data || error);
    throw error;
  }
};

// UPDATE an existing form assignment
export const updateFormAssignment = async (id, formAssignmentData) => {
  try {
    const response = await axiosInstance.put(`${API_URL}/form-assignments/${id}`, formAssignmentData);
    return response.data;
  } catch (error) {
    console.error("Error updating form-assignments:", error.response?.data || error);
    throw error;
  }
};

// DELETE a form assignment
export const deleteFormAssignment = async (id) => {
  try {
    const response = await axiosInstance.delete(`${API_URL}/form-assignments/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error deleting form-assignments:", error.response?.data || error);
    throw error;
  }
};
